/**
 * This class defines default settings for newly created Object3D instances.
 */
export class Default {
  /** The default setting for 'focusable' for newly created Object3Ds. */
  public static focusable = true;
  /** The default setting for 'draggable' for newly created Object3Ds. */
  public static draggable = false;
  /** The default setting for 'interceptByRaycaster' for newly created Object3Ds. */
  public static interceptByRaycaster = true;
}
